import React from "react";
import styles from "./locale-nav.module.scss";
import useLocales from "./useLocales";
import { Link } from "react-router-dom";

const LocaleNav = () => {
  const { data, loading } = useLocales();

  if (loading || !data) {
    return null;
  }

  return (
    <ul>
      {data.locales.map(({ id, title, uri }) => {
        return (
          <li key={id}>
            <Link to={`/${uri}`}>{title}</Link>
          </li>
        );
      })}
    </ul>
  );
};

export default LocaleNav;
